import React, { useEffect, useState } from 'react';

import * as rsuite from 'rsuite'
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useNavigate, useParams } from "react-router-dom";
import * as General from '../../General/General';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "rsuite/dist/rsuite-rtl.min.css";
import { MdOutlineMenu } from "react-icons/md";
import SharedTopic from '../../Components/Frame/SharedTopic';
import { Interweave } from 'interweave';
import { GiServerRack } from 'react-icons/gi';
const Show = () => {


    //#region Constants
    let navigate = useNavigate();

    let { PId } = useParams();
    let { TId } = useParams();

    const [Nodes, setNodes] = useState([]);
    const [NodeId, setNodeId] = useState(General.GuidEmpty());
    const [Collapse, setCollapse] = React.useState(false);
    const [Title, setTitle] = useState("");
    const [Content, setContent] = useState('');
    const [ShowLoader, setShowLoader] = useState(false);
    const [Comment, setComment] = useState("");
    const [createDate, setCreateDate] = useState("");
    const [Code, setCode] = useState("");
    const [Search, setSearch] = useState("");
    const [Result, setResult] = useState([]);
    const [ShowResult, setShowResult] = useState(false);
    //#endregion Constants
    //#region methods 




    const SearchFn = () => {
        setShowLoader(true);
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/Topic/Search?Search=" + Search,
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY

            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setResult(res.data);
                setShowResult(true);
                setShowLoader(false);
            })

            .catch(error => {
                setShowLoader(false);
            })
    }

    const Bind = (Id) => {
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/Topic/GetById",
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
                "Id": Id
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setTitle(res.data.title);
                setCode(res.data.code);
                setComment(res.data.comment);
                setContent(res.data.content);
                setCreateDate(res.data.createDate);
            })

            .catch(error => {

            })
    }
    const BindTree = () => {
        var RequestOption = {
            method: "Post",
            url: General.ApiRoute() + "/Topic/BindTree",
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
                "ProjectId": PId,
                "IsActive": 1
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setNodes(res.data);
                console.dir(res.data);
            })

            .catch(error => {

            })
    }



    useEffect(() => {
        BindTree();
        Bind(TId);
    }, [])
    useEffect(() => {
        if (NodeId != General.GuidEmpty()) {

            navigate("/Show/" + PId + "/" + NodeId, { replace: true });
            Bind(NodeId);
            setShowResult(false);
        }
    }, [NodeId])


    //#endregion methods
    return (
        <SharedTopic>
            <div style={{ display: 'flex', height: '100vh', direction: 'rtl', backgroundColor: "#fff" }}>
                <Sidebar rtl collapsed={Collapse} collapsedWidth="0px">
                    <div style={{ direction: 'rtl' }}>
                        {
                            Nodes.length == 0 ?
                                <rsuite.Loader center content="در حال بارگذاری ..." />
                                :

                                <rsuite.Tree
                                    searchable
                                    data={Nodes}
                                    value={NodeId}
                                    onChange={(value) => { setNodeId(value) }}
                                    height={2000}

                                    renderTreeNode={node => {
                                        return (
                                            <>
                                                {node.label}
                                            </>
                                        );
                                    }}
                                />
                        }
                    </div>
                </Sidebar>
                <div style={{
                    flex: 1,
                    overflowY: 'auto',
                    padding: '1rem',
                    height: '100vh'
                }}>

                    <main className='w-100  '>

                        <rsuite.Container>
                            <rsuite.Row>
                                <rsuite.Col xs={4}>
                                    <MdOutlineMenu size={25} onClick={() => setCollapse(!Collapse)} />

                                </rsuite.Col>
                                <rsuite.Col xs={20} className='text-left'>
                                    <rsuite.InputGroup     >
                                        <rsuite.Input
                                            type="text"
                                            value={Search}

                                            placeholder='جستجو در اسناد راهنما'
                                            onChange={value => setSearch(value)}
                                        />
                                        {
                                            !ShowLoader ?
                                                <rsuite.InputGroup.Button onClick={SearchFn}>
                                                    جستجو
                                                </rsuite.InputGroup.Button>
                                                :
                                                <rsuite.Button  disabled>
                                                    <rsuite.Loader content="در حال ارسال اطلاعات..." />
                                                </rsuite.Button>

                                        }
                                    </rsuite.InputGroup>
                                </rsuite.Col>
                                <rsuite.Divider className='mt-5' />
                            </rsuite.Row>
                            {
                                TId != General.GuidEmpty() || Code==="" ?
                                    <rsuite.Row>
                                        <rsuite.Col xs={24} >
                                            <rsuite.Panel className='w-100 bg-white p-1'>
                                                <rsuite.Tag color="blue" className='mb-2'>
                                                    {Code}
                                                </rsuite.Tag>
                                                <rsuite.Tag className='mb-2'>
                                                    {createDate}
                                                </rsuite.Tag>
                                                <h3>
                                                    {Title}
                                                </h3>
                                                <rsuite.Text muted className='pt-2 pb-5'>
                                                    {Comment}
                                                </rsuite.Text>
                                                <Interweave content={Content} />
                                            </rsuite.Panel>

                                        </rsuite.Col>
                                    </rsuite.Row> :
                                    <rsuite.Row>
                                        <rsuite.Col xs={24} >
                                            <rsuite.Panel className='w-100 bg-white p-1' align="center">
                                                <h3>
                                                    لطفا یک موضوع را انتخاب کنید
                                                </h3>
                                            </rsuite.Panel>
                                        </rsuite.Col>
                                    </rsuite.Row>
                            }


                        </rsuite.Container>

                    </main>
                </div>
            </div >

            <rsuite.Modal open={ShowResult} onClose={() => setShowResult(false)} size="full">
                <rsuite.Modal.Header>
                    <rsuite.Modal.Title>نتیجه جستجو</rsuite.Modal.Title>
                </rsuite.Modal.Header>
                <rsuite.Modal.Body>
                    <br /><br />
                    {
                        Result.map(item =>
                            <div onClick={() => setNodeId(item.id)} className='Hand'>

                                <b>
                                    {item.title}
                                </b>
                                <rsuite.Text muted>
                                    {item.comment}
                                </rsuite.Text>
                                <rsuite.Divider />
                            </div>

                        )
                    }
                </rsuite.Modal.Body>
            </rsuite.Modal>

        </SharedTopic>
    )
}

export default Show;